import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tiles, MessageCard, Loader, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import permissionLevel from '../../services/permissions.js';
import { toggleAvailability } from '../../actions/master.js';


class Index extends PureComponent {
    state = {};

    _toggleAvailability = () => {
        this.props.dispatch(toggleAvailability());
    };

    render() {
        const { accessType } = this.props;

        if (!this.props.master.status) {
            return <Loader isContainer/>;
        }

        let tiles = [
            {
                title: 'Claims',
                description: 'View and adjudicate member claims.',
                // eslint-disable-next-line no-return-assign
                onClick: () => window.location.href = '/adjudication/claims',
                testid: 'adjudication-tile'
            }
        ];

        permissionLevel('Adjudication', accessType).includes('write') &&
            tiles.push({
                title: 'Create Claim',
                description: 'Submit a manual claim for a member.',
                // eslint-disable-next-line no-return-assign
                onClick: () => window.location.href = '/adjudication/createClaim'
            });

        permissionLevel('Adjudication', accessType).includes('write') &&
            tiles.push({
                title: 'Simply Dental',
                description: 'View and submit dental transactions and access dental resources.',
                // eslint-disable-next-line no-return-assign
                onClick: () => window.location.href = '/adjudication/simplyDental',
                icon: 'Bird'
            });

        permissionLevel('Adjudication', accessType).includes('write') &&
            tiles.push({
                title: 'Predeterminations',
                description: 'View and manage Predeterminations.',
                // eslint-disable-next-line no-return-assign
                onClick: () => window.location.href = '/adjudication/predeterminations',
                icon: 'Claims'
            });

        return (
            <ContainerControlSite background={"true"}>
                <Header
                    subHeader="Adjudication"
                    selectedTitle="adjudication"
                />

                <Content>
                    <MessageCard
                        isError={ this.props.master.status.toUpperCase() === 'UNAVAILABLE' }
                        title={`You are ${ this.props.master.status } for adjudication`}
                        subtitle="Use the button below to toggle your adjudication availability. Claims will not be assigned to you while you are marked Unavailable."
                        btn
                        btnName={ this.props.master.status.toUpperCase() === 'AVAILABLE' ? 'I am unavailable' : 'I am available' }
                        btnOnClick={this._toggleAvailability}
                        btnCustomStyle={{ backgroundColor: this.props.master.status.toUpperCase() === 'UNAVAILABLE' && '#DA3328' }}
                    />

                    <Tiles tiles={tiles} />
                </Content>

                <span id="adjudicationOrCreateClaim" />
            </ContainerControlSite>
        );
    }
}

Index.propTypes = {
    master: PropTypes.object,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    master: state.master,
    accessType: state.master.access
});

export default connect(mapStateToProps)(Index);